export default {
  'New Request': 'Save and Do not notify',
  'In Progress': 'Save and Do not notify',
  Approved: 'Save and Notify Employee',
  'Need More Info': 'Save and Notify Employee',
  Delete: 'Delete and Close',
  Declined: 'Save and Notify Employee',
}
